










import { GroupLevelAttributeOption } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { deepCopy } from '@/jbi-shared/util/deep-copy.util';
import { GroupLevelAttributeContactsType } from '@/store/modules/admin/types/group-level-attribute.types';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ContactOption extends Vue {
  @Prop(Object) contactType!: GroupLevelAttributeContactsType;
  @Prop(Number) index!: number;
  @Prop(Number) contactListLength!: number;
  clonedContactType: GroupLevelAttributeContactsType | null = null;
  contactOptions: GroupLevelAttributeOption[] = [];

  mounted() {
    this.clonedContactType = deepCopy(this.contactType);
  }

  get isLastItem() {
    return this.index === this.contactListLength - 1;
  }
}
